import * as VEHICLE_SPECIFICATIONS from './vehicleSpecifications/index.js'
import * as AD_DETAIL_PAGE_SECTIONS from './adDetailPageSections.js'
import * as BREADCRUMBS from './breadcrumbs.js'
import {CONSENTS} from './consents.js'
import {BUYER_INTENTIONS, CONTACT_DEFAULT_MESSAGE} from './contactSeller.js'
import * as COOKIES from './cookies.js'
import {CSAT_NPS} from './csatNps.js'
import {TIME_UNIT} from './dates.js'
import {ERROR_CODES} from './errorCodes.js'
import * as ERROR_RESPONSES from './errorResponses.js'
import ERRORS from './errors.js'
import * as FILTERS_AGGREGATIONS from './filtersAggregations.js'
import * as FILTERS_GROUPS from './filtersGroups.js'
import * as FILTERS_HELP_TEXTS from './filtersHelpTexts.js'
import * as FILTERS_LABELS from './filtersLabels.js'
import {FILTERS_OPTIONS} from './filtersOptions.js'
import {FILTERS_PLACEHOLDERS} from './filtersPlaceholders.js'
import HTTP_RESPONSE_CODES from './httpResponseCodes.js'
import HTTP_STATUS_CODES from './httpStatusCodes.js'
import {LISTING_SECTION_IDS} from './listingSections.js'
import * as AI_ASSISTANT from './netAiAssistant.js'
import * as NEWS from './news.js'
import * as PAGE from './page.js'
import {PATHS, SECTION_PATHS} from './paths.js'
import {QUERY_PARAMS} from './queryParams.js'
import * as RATINGS from './ratings.js'
import {RECOMMENDED_ADS} from './recommendedAds.js'
import * as SCARCITY from './scarcity.js'
import * as SEARCH_AI from './searchAi.js'
import * as SEARCH_SAVE from './searchSave.js'
import SERVICE_PROVIDERS from './serviceProviders.js'
import * as SHARE from './share.js'
import * as TAXES from './taxes.js'
import {ELECTRIC_CHARGING_TIME_TRACKING_TYPES, HIGHLIGHT_TYPES, UTM_TAGS_VALUES} from './tracking.js'
import * as USER from './user.js'

export const COMMON = {
  ...COOKIES,
  ...FILTERS_AGGREGATIONS,
  ...FILTERS_LABELS,
  ...NEWS,
  ...USER,
  AD_DETAIL_PAGE_SECTIONS,
  AI_ASSISTANT,
  BREADCRUMBS,
  BUYER_INTENTIONS,
  CONTACT_DEFAULT_MESSAGE,
  CONSENTS,
  CSAT_NPS,
  ELECTRIC_CHARGING_TIME_TRACKING_TYPES,
  ERRORS,
  ERROR_CODES,
  ERROR_RESPONSES,
  FILTERS_GROUPS,
  FILTERS_HELP_TEXTS,
  FILTERS_OPTIONS,
  FILTERS_PLACEHOLDERS,
  HIGHLIGHT_TYPES,
  HTTP_RESPONSE_CODES,
  HTTP_STATUS_CODES,
  LISTING_SECTION_IDS,
  PAGE,
  PATHS,
  QUERY_PARAMS,
  RATINGS,
  RECOMMENDED_ADS,
  SCARCITY,
  SEARCH_AI,
  SEARCH_SAVE,
  SECTION_PATHS,
  SERVICE_PROVIDERS,
  SHARE,
  TAXES,
  TIME_UNIT,
  UTM_TAGS_VALUES,
  VEHICLE_SPECIFICATIONS
}
